export const reservationReportFilterCookie = 'reservation-report-filter'
export const addonReportFilterCookie = 'addon-report-filter'
export const invoiceFilterCookie = 'invoice-filter'
export const paymentsReportFilterCookie = 'payments-report-filter'